<div class="flex justify-between h-[90vh]" [ngClass]="{ 'max-md:h-full': data.creatorBriefingMode }">
  <app-side-dialog class="w-full" [fullHeight]="true" [contentMarginTop]="0" (closeDialog)="onCloseClick()">
    <div dialogHeader class="flex flex-1 items-center w-full min-w-0">
      <!-- Mobile briefing sheet: "Back to overview" sits in the top bar instead of above the deliverable. -->
      @if (mobileBriefing() && detailViewOpen()) {
        <button
          mat-flat-button
          type="button"
          color="transparent"
          class="!h-11 !px-2"
          data-testid="cta-analytics-dialog-back-to-overview"
          (click)="onBackToOverviewClick()"
        >
          <div class="flex items-center gap-2">
            <app-icon src="icons/arrow-left.svg" [size]="18" />
            <span class="text-sm">{{ 'pages.campaignDetails.ctaAnalytics.details.backToOverview' | translate }}</span>
          </div>
        </button>
      }
    </div>

    <div class="dialog-content h-full" dialogContent>
      <app-cta-analytics-dialog-content
        [adminMode]="data.adminMode"
        [analyticsNode]="data.analyticsNode"
        [backToOverviewRequest]="backToOverviewRequest()"
        [briefingId]="data.briefingId ?? null"
        [campaign]="data.campaign"
        [campaignExport]="data.campaignExport"
        [campaignProcessStatus]="data.campaignAnalytics.processStatus"
        [creator]="data.analyticsNode.creator"
        [creatorBriefingMode]="data.creatorBriefingMode"
        [ctaResult]="currentCtaResult()!"
        [exportMode]="data.exportMode"
        [selectedDeliverableExecutionAnalytics]="selectedDeliverableExecutionAnalytics()"
        [selectedDeliverableId]="selectedDeliverableId()"
        [selectedDeliverableType]="selectedDeliverableType()"
        (ctaExecutionChange)="onExecutionChange($event)"
        (deliverableSelected)="deliverableSelected($event)"
        (detailViewChange)="detailViewOpen.set($event)"
        (overviewRequested)="onOverviewRequested()"
      />
    </div>
  </app-side-dialog>
</div>
